import {
  FETCH_LEAGUE_LIST,
  FETCH_FILTER_INFO,
} from '../mutation-types'

const initialState = {
  league: [],
  recommend: [],
  filterInfo: {},
}

const mutations = {
  [FETCH_LEAGUE_LIST](state, data) {
    state.league = data.leagues
    // filter the first four recommend match
    state.recommend = state.league
      .filter(l => l.isRecommended)
      .slice(0, 4)
      .sort((a, b) => b.recommendedDate - a.recommendedDate)
  },

  [FETCH_FILTER_INFO](state, data) {
    state.filterInfo = data
  },
}

export default {
  state: initialState,
  mutations,
}



// WEBPACK FOOTER //
// ./client/vuex/modules/league.js